import { AmountDataHolder } from './amountDataHolder';
import {DocumentStatus, ExtendedDocument} from './DocumentsTypes/Document';
import {dateObjectToString, roundDecimals} from '../fromKotlin/nkutils';
import JSDB from '../fromKotlin/nk';


export interface CartesetDataHolder {
    id: number;
    doc: ExtendedDocument;
    status: DocumentStatus;
    name: string;
    agent: string;
    date: Date;
    dateIssue: Date;
    amount_tn: number;
    value_tn: number;
    open_tn: number;
    amount_pay: number;
    value_pay: number;
    debt: number;
    type: string;
    yearly?: number;
    comment?:string;
    notes5?:string;
    cname:string
}

export type BuildDebtsOptions = {
    /**
     * Oldest→newest (farthest date first).
     * Default: true when user.add_carteset === 5, else false (newest first).
     */
    chronological?: boolean;
};

/** add_carteset=5 → show carteset from farthest date to closest. */
export const isCartesetChronological = (): boolean =>
    JSDB().getUser().first?.add_carteset === 5;

export const buildDebts = (
    carteset: CartesetDataHolder[],
    startDate: Date,
    options?: BuildDebtsOptions,
): CartesetDataHolder[] => {
    let s = 0
    const chronological = options?.chronological ?? isCartesetChronological()

    const carteset_midterm = carteset.filter((s)=>s.yearly==1).sort((a, b) => a.date==b.date? (a.doc.type ==b.doc.type ? (a.id-b.id):(a.doc.nkObject.type.getConnectedType()-b.doc.nkObject.getConnectedType()))  :a.date.getTime()-b.date.getTime())

    const carteset_midterm_real = carteset.filter((s)=>!s.yearly)
    carteset_midterm.forEach((c)=>{
      if(dateObjectToString(c.date)==dateObjectToString(startDate)){
          carteset_midterm_real.push(c)
      }
    })

    carteset_midterm_real.sort((a, b) => a.date==b.date? (a.doc.type ==b.doc.type ? (a.id-b.id):(a.doc.nkObject.type.getConnectedType()-b.doc.nkObject.getConnectedType()))  :a.date.getTime()-b.date.getTime())

    carteset_midterm_real.forEach((c)=>{
        c.debt = roundDecimals(s + c.value_tn - c.value_pay,2)
        s = c.debt
    })

    // Default display is newest→oldest; add_carteset=5 keeps oldest→newest.
    if (!chronological) {
        carteset_midterm_real.reverse()
    }

    return carteset_midterm_real;
};
